import { Rate } from 'element-ui'

const YRate = Rate
YRate.$depends = [Rate]
YRate.$name = 'y-rate'
YRate._name = 'Rate 评分'

export default YRate
